<template>
<div class="row">
<div class="iframes-container" v-for="item in content" :key="item.link">
  <h4 class="title">{{item.country}}</h4>
  <div class="iframes-content">
    <img class="loading_icon" src="~images/loading_icon.gif" />
    <iframe ref="iframe" :src="item.link" frameborder="0" scrolling="no"></iframe>
  </div>
</div>
</div>
</template>

<script>
/* globals iFrameResize */
import "iframe-resizer/js/iframeResizer.min";

export default {
  props: ["attributes"],
  computed: {
    content() {
      const items = this.attributes.value.items;
      return items;
    },
    // maxWidth() {
    //   const { maxwidth } = this.attributes;
    //   return maxwidth || "auto";
    // },
  },
  mounted() {
    iFrameResize({}, this.$refs.iframe);
  },
};
</script>

<style lang="scss">
.row {
  content: "";
  display: table;
  clear: both;
}

.iframes-container {
  width: 100%;
  margin: auto;
  // margin: 10px;

  .iframes-content {
    height: 260px;
    overflow: hidden;
    position: relative;
    // margin: 0 auto;

    .loading_icon {
      position: absolute;
      width: 50%;
      opacity: 0.4;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    iframe {
      width: 100%;
      position: absolute;
      top: -10px;
      // left: -100px;
      height: 350px;
      margin-top: -100px !important;
      overflow: hidden;
    }
  }

  @media screen and (min-width: 600px) {
    float: left;
    width: 50%;
    iframe {
      max-width: 400px;
    }
  }

  @media screen and (min-width: 800px) {
    float: left;
    width: 33.3%;
    iframe {
      max-width: 400px;
    }
  }

  @media screen and (min-width: 1000px) {
    float: left;
    width: 33.3%;

    iframe {
      max-width: 400px;
    }
  }
}
</style>
